import { subQuarters } from 'date-fns';

import { getCurrentQuarter } from '.';

export const getPriorQuarters = (now: Date, amount: number): DateRange[] => {
    if (amount < 1) {
        return [];
    }

    const dateInPriorQuarter = subQuarters(now, 1);
    const datesWithinQuarters = [dateInPriorQuarter];

    while (datesWithinQuarters.length < amount) {
        datesWithinQuarters.unshift(subQuarters(datesWithinQuarters[0], 1));
    }

    return datesWithinQuarters.map(
        (dateWithinQuarter: Date): DateRange =>
            getCurrentQuarter(dateWithinQuarter),
    );
};
